
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/purolator/specialized-services",
      function () {
        return require("private-next-pages/partners/purolator/specialized-services.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/purolator/specialized-services"])
      });
    }
  